import { useEffect, useState } from "react";

const NAME = "Bloomwell";

export const AppMark = ({ className = "h-10" }) => (
  <img src="/brand/bloomwell-logo-white.png" alt={NAME} data-testid="app-mark" className={`${className} w-auto object-contain`} />
);

export const AppLogo = ({ light, className = "h-10" }) => (
  <img src={light ? "/brand/bloomwell-logo-white.png" : "/brand/bloomwell-logo.png"} alt={NAME} data-testid="app-logo" className={`${className} w-auto object-contain`} />
);

const dropBackground = (px) => {
  if (px[3] < 200) return;
  const [r0, g0, b0] = [px[0], px[1], px[2]];
  for (let i = 0; i < px.length; i += 4) {
    if (Math.abs(px[i] - r0) + Math.abs(px[i + 1] - g0) + Math.abs(px[i + 2] - b0) < 60) px[i + 3] = 0;
  }
};

const whiten = (src) => new Promise((resolve) => {
  const img = new Image();
  img.onload = () => {
    try {
    const c = document.createElement("canvas");
    c.width = img.naturalWidth; c.height = img.naturalHeight;
    const ctx = c.getContext("2d");
    ctx.drawImage(img, 0, 0);
    const d = ctx.getImageData(0, 0, c.width, c.height);
    dropBackground(d.data);
    const colours = new Set();
    for (let i = 0; i < d.data.length; i += 4) {
      if (d.data[i + 3] > 200) colours.add(((d.data[i] >> 3) << 10) | ((d.data[i + 1] >> 3) << 5) | (d.data[i + 2] >> 3));
    }
    for (let i = 0; i < d.data.length; i += 4) {
      const [r, g, b] = [d.data[i], d.data[i + 1], d.data[i + 2]];
      if (colours.size > 400 || Math.max(r, g, b) - Math.min(r, g, b) < 60) { d.data[i] = d.data[i + 1] = d.data[i + 2] = 255; }
    }
    ctx.putImageData(d, 0, 0);
    resolve(c.toDataURL("image/png"));
    } catch { resolve(src); }
  };
  img.onerror = () => resolve(src);
  img.src = src;
});

const isLight = (src) => new Promise((resolve) => {
  const img = new Image();
  img.onload = () => {
    const c = document.createElement("canvas");
    c.width = img.naturalWidth; c.height = img.naturalHeight;
    const ctx = c.getContext("2d");
    ctx.drawImage(img, 0, 0);
    let d;
    try { d = ctx.getImageData(0, 0, c.width, c.height).data; } catch { resolve(false); return; }
    if (d[3] > 200) { resolve(false); return; }
    let sum = 0, n = 0;
    for (let i = 0; i < d.length; i += 4) {
      if (d[i + 3] > 200) { sum += (0.299 * d[i] + 0.587 * d[i + 1] + 0.114 * d[i + 2]) / 255; n += 1; }
    }
    resolve(n > 0 && sum / n > 0.6);
  };
  img.onerror = () => resolve(false);
  img.src = src;
});

export function AutoLogo({ src, alt, className = "", testId }) {
  const [light, setLight] = useState(null);
  useEffect(() => { let on = true; isLight(src).then((v) => on && setLight(v)); return () => { on = false; }; }, [src]);
  if (light === null) return <span className={`${className} inline-block`} />;
  const img = <img src={src} alt={alt} data-testid={testId} className={`${className} w-auto object-contain`} />;
  return light ? <span className="inline-flex rounded-2xl bg-[hsl(330_8%_12%)] px-5 py-3" data-testid={`${testId}-tile`}>{img}</span> : img;
}

export function LightLogo({ src, className = "", testId }) {
  const [out, setOut] = useState("");
  useEffect(() => { let on = true; whiten(src).then((u) => on && setOut(u)); return () => { on = false; }; }, [src]);
  if (!out) return <span className={`${className} inline-block`} />;
  return <img src={out} alt="logo" data-testid={testId} className={`${className} w-auto object-contain rounded-md`} />;
}
